import { cx } from '../cx';

export function Spinner({ className, label = 'Chargement' }: { className?: string; label?: string }) {
  return <span className={cx('ui-spinner', className)} role="status" aria-label={label} />;
}
